import { appConfig, headerConfig, refineHeader } from "../../config";

export const subAdminService = {
  add_subadmin,
  get_user_list,
  delete_user,
  update_user,
  get_user_details,
  get_afuser_details,
  allUser,
  storeCredit,
  storePreview,
  get_employee_list,
  get_permission_list,
  savePermission
};

function add_subadmin(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}user/subadmin`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_employee_list(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}user/employee-list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function savePermission(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}permission/save-permissions`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_permission_list(url) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      
      return data.data;
    });
}

function get_user_list(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}user/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function allUser(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}user/store-credit-users`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function delete_user(userIdAsParams) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}user/delete/${userIdAsParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_user(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}user/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function get_user_details(userIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}user/detail/${userIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function get_afuser_details(userIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}user/afdetail/${userIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function storeCredit(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}store-credit/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function storePreview(userID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(
    `${appConfig.api.url}store-credit/user-store-transactions-list/${userID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/subAdminService.js